export default [
  {
    key: 'companyName',
    label: 'field.companyName',
    rules: 'required|min:2|max:50',
    type: 'text',
    cols: 12,
  },
  {
    key: 'businessTypeId',
    label: 'field.businessType',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'businessType',
    selectionKey: 'id',
    selectionLabel: 'translations',
    cols: 12,
  },
]
